import { Injectable, inject } from '@angular/core';
import { decodeJwtPayload } from '@clinic-platform/shared-types';
import { TokenStorageService } from '../../../core/auth/token-storage.service';
import { SaveClinicSettingsRequest } from './settings.models';

@Injectable({ providedIn: 'root' })
export class ClinicSaveDraftStore {
  private readonly tokens = inject(TokenStorageService);

  private key(clinicId: string, companyId?: string): string {
    const actor = decodeJwtPayload<{ sub?: string; companyId?: string }>(
      this.tokens.getAccessToken() ?? '',
    );
    if (!actor?.sub || !(companyId || actor.companyId))
      throw new Error('Missing clinic save scope');
    return `clinic-save:v1:${actor.sub}:${companyId || actor.companyId}:${clinicId}`;
  }

  load(clinicId: string, companyId?: string): SaveClinicSettingsRequest | null {
    const stored = sessionStorage.getItem(this.key(clinicId, companyId));
    if (!stored) return null;
    const draft = JSON.parse(stored) as SaveClinicSettingsRequest;
    if (!draft.operationId || !Array.isArray(draft.procedureTypeIds))
      throw new Error('Invalid pending clinic save');
    return draft;
  }

  remember(
    clinicId: string,
    companyId: string | undefined,
    request: SaveClinicSettingsRequest,
  ): void {
    // Only operational settings/ids, never credentials or client contact data.
    sessionStorage.setItem(
      this.key(clinicId, companyId),
      JSON.stringify(request),
    );
  }

  clear(clinicId: string, companyId?: string): void {
    sessionStorage.removeItem(this.key(clinicId, companyId));
  }
}
